function wpmlDropdown() {
    const dropdownTriggers = document.querySelectorAll('.js-show-wpml-langs');

    if (dropdownTriggers.length > 0) {
        dropdownTriggers.forEach(el => {
            const dropdownLangs = el.querySelector('.js-wpml-langs');
            
            el.addEventListener('mouseenter', e => {
                const langsHeight = dropdownLangs.getAttribute('data-dropdown-height');
                dropdownLangs.style.height = langsHeight + 'px';
            });

            el.addEventListener('mouseleave', e => dropdownLangs.style.height = '0px')
        })
    }
}

wpmlDropdown();